import { Grid, Typography } from '@mui/material';
import {
  MTE_GLOBALS_MAPPING,
  RETROACTIVE_PERIODS,
  type composeGlobalDeltas,
} from '../../helpers/coverage-summary.utils';
import {
  CoverageGridCell,
  DeltaGridCell,
  TypographyUppercase,
} from '../CoverageGridCell';
import { formatCurrencyToTenthsPlaceWithUnit } from '../../../../../../../../utils/currency.utils';
import CoverageCheckbox from '../../../../../../../agencies/quotes/PrimeX/customizeQuote/components/CoverageCheckbox';

interface GlobalProps {
  mergedGlobals: ReturnType<typeof composeGlobalDeltas>;
  showAllDetails: boolean;
}

export const Global = ({ mergedGlobals, showAllDetails }: GlobalProps) => {
  if (!mergedGlobals) {
    return null;
  }

  return (
    <>
      {mergedGlobals.map((global, idx) => {
        if (!showAllDetails && !global.isDelta) {
          return null;
        }

        const isOdd = idx % 2 === 0;

        return (
          <Grid container key={global.label}>
            <DeltaGridCell
              isDelta={global.isDelta}
              item
              md={3}
              isOdd={isOdd}
              sx={{ padding: '1rem' }}
            >
              <TypographyUppercase variant="caption">
                {global.label}
              </TypographyUppercase>
            </DeltaGridCell>

            <CoverageGridCell item md={3} isOdd={isOdd}>
              <Typography variant="caption">
                {formattedGlobal({ label: global.label, value: global.policy })}
              </Typography>
            </CoverageGridCell>

            <CoverageGridCell item md={3} isOdd={isOdd}>
              <Typography variant="caption">
                {formattedGlobal({
                  label: global.label,
                  value: global.endorsement,
                })}
              </Typography>
            </CoverageGridCell>

            <CoverageGridCell item md={3} isOdd={isOdd}>
              {' '}
            </CoverageGridCell>
          </Grid>
        );
      })}
    </>
  );
};

const formattedGlobal = ({ label, value }: { label: string; value: any }) => {
  if (label === MTE_GLOBALS_MAPPING.retroactivePeriod) {
    return RETROACTIVE_PERIODS[value as keyof typeof RETROACTIVE_PERIODS];
  }

  if (label === MTE_GLOBALS_MAPPING.waitingPeriod) {
    return value;
  }

  if (label === MTE_GLOBALS_MAPPING.hasTria) {
    return getCheckBoxIcon(value);
  }

  return formatCurrencyToTenthsPlaceWithUnit(value);
};

const getCheckBoxIcon = (value: string | boolean) => {
  if (value === true || value === 'true') {
    return <CoverageCheckbox.Selected disabled label="" />;
  }

  return <CoverageCheckbox.Available disabled label="" />;
};
